import { useState } from 'react';
import { Grid, Box, TextField, Button, Typography, Paper, Avatar } from '@mui/material';
import axiosBase from '../common/axiosBase';
import coreConfig from '../common/coreConfig';
import SterisLogoPNG from '../styles/img/STERIS-Logo.png';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Link, useNavigate } from 'react-router-dom';
import { useStateContext } from "@durlabh/dframework-ui";
import MicrosoftIcon from '@mui/icons-material/Microsoft';
import LoadingDialog from '../common/loadingDialog';

const formSX = {
    '& .MuiInputLabel-asterisk': { color: 'error.main', fontWeight: 'bold' }
};

const { authMethods, isBasicAuth } = coreConfig;
function LoginPage({ userData = {}, setUserData }) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [touched, setTouched] = useState({ username: false, password: false });
    const navigate = useNavigate(); // Initialize useNavigate hook
    const { dispatchData } = useStateContext();
    const [isLoading, setIsLoading] = useState(false);
    
    const redirectToLogin = () => {
        const backendUrl = coreConfig.backendUrl;
        window.location.href = `${backendUrl}/auth/login`;
    };

    const handleLogin = async (method) => {
        // for entraId authentication, redirect to the /auth/login endpoint
        if(method === authMethods.entraIdAuth) {
            redirectToLogin();
            return;
        }
        if (method === authMethods.basicAuth && (!username || !password)) {
            setTouched({ username: true, password: true });
            return;
        }
        try {
            setIsLoading(true);
            const response = await axiosBase({
                api: coreConfig.apiConfig.endpoints.login,
                method: coreConfig.apiConfig.reqMethod.POST,
                body: { username, password, methodKey: method }
            });
            setIsLoading(false);
            if (!response.data.success) {
                setError('Invalid credentials');
                return;
            }
            const { permissions, userDetails, menuDetails } = response?.data || {};
            dispatchData({
                type: 'USER_DATA', payload: { permissions, userDetails, menuDetails }
            });
            setUserData({ userDetails, isLoggedIn: true, permissions, menuDetails });
            } catch {
                setError('Failed to login. Please try again.');
            }
    };

    const handleUsernameChange = (e) => {
        const value = e.target.value;
        setUsername(value);
    };

    if (userData.userDetails) {
        navigate('/dashboard');
    }
    return (
        <div className="wrapper wrapper-content">
            <LoadingDialog open={isLoading} message="Logging in..." />
            <Paper
                sx={{
                    justifyContent: 'center',
                    margin: 'auto',
                    maxWidth: '500px',
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '20px',
                    alignItems: 'center',
                    marginTop: '109px'
                }}
            >
                <img src={SterisLogoPNG} alt="logo" />
                <br />
                <h3>
                    Welcome to Scope Compatibility Matrix
                </h3>
                <Avatar>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Login
                </Typography>
                <Box component="form" sx={formSX} style={{ width: '100%' }}>
                    <div width="100%">
                        {isBasicAuth && <><Grid p={1} size={12}>
                            <TextField
                                label={"Email"}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                required
                                autoComplete="new-password"
                                value={username}
                                onChange={handleUsernameChange}
                                error={touched.username && (!username)}
                                helperText={touched.username ? (!username.length ? "Email is required" :
                                    (!username ? "Invalid email format" : ""))
                                    : ""}
                            />
                        </Grid>
                            <Grid p={1}>
                                <TextField
                                    label="Password"
                                    variant="outlined"
                                    margin="normal"
                                    type="password"
                                    autoComplete="new-password"
                                    fullWidth
                                    autoFocus
                                    required
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    error={touched.password && !password}
                                    helperText={touched.password && !password ? "Password is required" : ""}
                                />

                                {error && (
                                    <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                                        {error}
                                    </Typography>
                                )}
                            </Grid>
                            <Grid p={1}>
                                <Button fullWidth variant="contained" color="primary" onClick={() => { handleLogin(authMethods.basicAuth); }} >
                                    <Typography color="white" component="h4" variant="p" align='center'>
                                        Login
                                    </Typography>
                                </Button>
                            </Grid></>}
                        <Grid p={1}>
                            <Button fullWidth variant="contained" color="primary" onClick={() => { handleLogin(authMethods.entraIdAuth); }} startIcon={<MicrosoftIcon />} >
                                <Typography color="white" component="h4" variant="p" align='center'>
                                    Sign in with Microsoft
                                </Typography>
                            </Button>
                        </Grid>
                        {isBasicAuth && <Grid p={1} style={{ paddingLeft: '37%' }}>
                            <Link variant="body2">
                                FORGOT PASSWORD?
                            </Link>
                        </Grid>}
                    </div>
                </Box>
                <Box mt={5}>
                    Copyright &copy; STERIS Corporation {new Date().getFullYear()}
                </Box>
            </Paper>
        </div>
    );
}

export default LoginPage;
